const postCloneEquipmentModels = {
  toastr: 'Tipo de Equipamento Clonado',
  toastr1: ' foi adicionado com sucesso',
  toastrError: 'Nome já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default postCloneEquipmentModels;
